(() => {
  const DEFAULT_CONFIG = {
    linkText: "Size Chart",
    pageHandle: "size-guide",
    variantName: "Size",
    stripedRows: true,
  };

  const pageCache = new Map();
  let modalNode = null;

  function loadConfig() {
    const node = document.getElementById("quick-add-size-guide-config");
    if (!node) return { ...DEFAULT_CONFIG };

    try {
      return { ...DEFAULT_CONFIG, ...JSON.parse(node.textContent) };
    } catch (error) {
      console.error("Quick add size guide config parse failed:", error);
      return { ...DEFAULT_CONFIG };
    }
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function normalizeLabel(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function isSizeOption(optionLabel, config = loadConfig()) {
    if (!config.pageHandle) return false;
    return normalizeLabel(optionLabel) === normalizeLabel(config.variantName);
  }

  function renderLink(optionLabel, config = loadConfig()) {
    if (!isSizeOption(optionLabel, config)) return "";

    return `
      <div class="wt-product__option__size-guide quick-add-ajax__size-guide">
        <button
          type="button"
          class="wt-product__button wt-product__link quick-add-ajax__size-guide-link"
          data-qa-size-guide-open
          aria-haspopup="dialog"
        >
          ${escapeHtml(config.linkText)}
        </button>
      </div>
    `;
  }

  function renderOptionHeader(optionLabel, selectedValue = "", config = loadConfig()) {
    const hasSelectedValue = Boolean(selectedValue);
    const sizeGuideLink = renderLink(optionLabel, config);

    return `
      <div class="quick-add-ajax__option-header">
        <div class="wt-product__option__title quick-add-ajax__option-title">
          <span class="quick-add-ajax__option-name" data-option-name="${escapeHtml(
            optionLabel,
          )}">${escapeHtml(optionLabel)}${hasSelectedValue ? ":" : ""}</span>
          ${
            hasSelectedValue
              ? `<span class="quick-add-ajax__option-value">${escapeHtml(
                  selectedValue,
                )}</span>`
              : ""
          }
        </div>
        ${sizeGuideLink}
      </div>
    `;
  }

  function ensureModal() {
    if (modalNode && document.body.contains(modalNode)) return modalNode;

    modalNode = document.createElement("div");
    modalNode.className = "qa-size-guide";
    modalNode.hidden = true;
    modalNode.setAttribute("aria-hidden", "true");
    modalNode.innerHTML = `
      <div class="qa-size-guide__overlay" data-qa-size-guide-close></div>
      <div
        class="qa-size-guide__dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Size guide"
      >
        <div class="qa-size-guide__top">
          <button
            type="button"
            class="qa-size-guide__close"
            data-qa-size-guide-close
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="qa-size-guide__content wt-product__modal--content-info rte">
          <p class="headline__title qa-size-guide__title"></p>
          <div class="qa-size-guide__body"></div>
        </div>
      </div>
    `;

    document.body.appendChild(modalNode);

    if (!modalNode.dataset.qaBound) {
      modalNode.addEventListener("click", (event) => {
        if (event.target.closest("[data-qa-size-guide-close]")) {
          event.preventDefault();
          close();
        }
      });

      modalNode
        .querySelector(".qa-size-guide__body")
        ?.addEventListener("change", (event) => {
          const input = event.target;
          if (input.type !== "radio") return;

          const bodyNode = event.currentTarget;
          const chartSelector = UNIT_RADIO_GROUPS[input.name];
          if (!chartSelector) return;

          const charts = bodyNode.querySelectorAll(chartSelector);
          charts.forEach((chart) => chart.classList.remove("on"));

          if (input.value === "inches" && charts[0]) {
            charts[0].classList.add("on");
          } else if (input.value === "centimeters" && charts[1]) {
            charts[1].classList.add("on");
          }
        });

      modalNode.dataset.qaBound = "true";
    }

    return modalNode;
  }

  function setModalState(modal, { loading = false, title = "", html = "", error = "" }) {
    const titleNode = modal.querySelector(".qa-size-guide__title");
    const bodyNode = modal.querySelector(".qa-size-guide__body");

    if (titleNode) {
      titleNode.textContent = title;
      titleNode.hidden = !title;
    }

    if (!bodyNode) return;

    if (loading) {
      bodyNode.innerHTML =
        '<p class="qa-size-guide__loading">Loading size chart...</p>';
      return;
    }

    if (error) {
      bodyNode.innerHTML = `<p class="qa-size-guide__error">${escapeHtml(error)}</p>`;
      return;
    }

    bodyNode.innerHTML = html;
    initPageContent(bodyNode);
  }

  const UNIT_RADIO_GROUPS = {
    occasion_units: ".sizechart_incm_occasion",
    Bridal_units: ".sizechart_incm_Bridal",
    dresses_units: ".sizechart_incm_dresses",
    FlowerGirl_units: ".sizechart_incm_FlowerGirl",
  };

  function initPageContent(root) {
    if (!root) return;

    const tabsRoot = root.querySelector(".jtabs2");
    if (!tabsRoot) return;

    const tabBar = tabsRoot.querySelector(".jtabs2-title");
    const tabPanels = tabsRoot.querySelectorAll(".jtabs2-content > div");

    tabBar?.addEventListener("click", (event) => {
      const tab = event.target.closest(".jtabs2-title > div");
      if (!tab || !tabBar.contains(tab)) return;

      const index = Array.from(tabBar.children).indexOf(tab);
      tabBar.querySelectorAll(":scope > div").forEach((el) => {
        el.classList.remove("on");
      });
      tabPanels.forEach((el) => el.classList.remove("on"));
      tab.classList.add("on");
      tabPanels[index]?.classList.add("on");
    });

    const measureTitle = root.querySelector(".jmeasure .title");
    const measureContent = root.querySelector(".jmeasure .contetn");
    if (measureTitle && measureContent) {
      measureTitle.addEventListener("click", () => {
        measureTitle.classList.toggle("on");
        const isHidden =
          measureContent.style.display === "none" ||
          (measureContent.style.display === "" &&
            window.getComputedStyle(measureContent).display === "none");
        measureContent.style.display = isHidden ? "block" : "none";
      });
    }
  }

  async function fetchPage(handle) {
    if (pageCache.has(handle)) {
      return pageCache.get(handle);
    }

    const response = await fetch(`/pages/${encodeURIComponent(handle)}.json`, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      throw new Error("Unable to load size chart.");
    }

    const data = await response.json();
    const page = data?.page;

    if (!page?.body_html) {
      throw new Error("Size chart content is unavailable.");
    }

    pageCache.set(handle, page);
    return page;
  }

  function isOpen() {
    return Boolean(modalNode?.classList.contains("qa-size-guide--open"));
  }

  function close() {
    if (!modalNode) return;

    modalNode.classList.remove("qa-size-guide--open");
    modalNode.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("qa-size-guide-locked");

    const modal = modalNode;
    const onEnd = () => {
      if (!modal.classList.contains("qa-size-guide--open")) {
        modal.hidden = true;
      }
    };

    const dialog = modal.querySelector(".qa-size-guide__dialog");
    if (dialog) {
      dialog.addEventListener("transitionend", onEnd, { once: true });
      setTimeout(onEnd, 350);
    } else {
      modal.hidden = true;
    }
  }

  async function open(config = loadConfig()) {
    const modal = ensureModal();
    const handle = config.pageHandle;

    if (!handle) return;

    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    void modal.offsetWidth;
    modal.classList.add("qa-size-guide--open");
    document.documentElement.classList.add("qa-size-guide-locked");

    setModalState(modal, { loading: true, title: config.linkText });

    try {
      const page = await fetchPage(handle);
      setModalState(modal, {
        title: page.title || config.linkText,
        html: page.body_html,
      });
    } catch (error) {
      setModalState(modal, {
        title: config.linkText,
        error: error.message || "Unable to load size chart.",
      });
    }

    modal.querySelector(".qa-size-guide__close")?.focus({ preventScroll: true });
  }

  function handleInteraction(event) {
    if (event.target.closest("[data-qa-size-guide-open]")) {
      event.preventDefault();
      open();
      return true;
    }

    return false;
  }

  window.QuickAddSizeGuide = {
    loadConfig,
    isSizeOption,
    renderLink,
    renderOptionHeader,
    open,
    close,
    isOpen,
    handleInteraction,
  };
})();
